import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const wrapper: SxStyle = {
  width: (p) => p.spacing(54),
};

export const title: SxStyle = {
  borderBottomColor: (p) => p.palette.grey[300],
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  padding: (p) => p.spacing(1, 2),
  width: (p) => p.spacing(60),
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  fontSize: (p) => p.typography.body2.fontSize,
  color: (p) => p.palette.grey[800],
};

export const content: SxStyle = {
  marginTop: (p) => p.spacing(2),
  padding: (p) => p.spacing(2),
  fontSize: (p) => p.typography.body3.fontSize,
  color: (p) => p.palette.grey[800],
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const actions: SxStyle = {
  borderTopColor: (p) => p.palette.grey[300],
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  py: (p) => p.spacing(1),
};
